import { useTheme } from "../context/ThemeContext";

const CoinsIcon = ({ active, color }) => {
  const { darkMode } = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1669_4003)">
        <path
          d="M10.5 13.5C13.8137 13.5 16.5 10.8137 16.5 7.5C16.5 4.18629 13.8137 1.5 10.5 1.5C7.18629 1.5 4.5 4.18629 4.5 7.5C4.5 10.8137 7.18629 13.5 10.5 13.5Z"
          stroke={active ? "white" : "#828282"}
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M9.87521 15.7267C9.04729 16.218 8.08064 16.5 7.04813 16.5C3.98398 16.5 1.5 14.016 1.5 10.9519C1.5 9.91936 1.78205 8.95272 2.2733 8.1248"
          stroke={active ? "white" : "#828282"}
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1669_4003">
          <rect width="18" height="18" fill={active ? "white" : "#828282"} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CoinsIcon;
